import { getState as getReduxState } from "../../../MapStore2/web/client/utils/StateUtils";

export const getState = () => {
    return getReduxState("persisted.reduxStore");
};
